










































































import Vue from 'vue';
import Component from 'vue-class-component';
import { setMonthFormatDate } from '@/modules/shared/shared/domain/functions/date-functions';
import * as rules from '@/modules/shared/shared/domain/rules';
import moment from 'moment';
import { DataCenters } from '@/modules/shared/shared/domain/constants/constants';
import { reportsManagement } from '@/modules/shared/shared/store/namespaces';
import { ReportsManagementActions } from '@/modules/reports/management/store/reports-management.actions';

@Component({
    name: 'download-report-modal',
})
export default class DownloadReportModal extends Vue {
    isLoading: boolean = false;
    dialog: boolean = false;
    dateMenu: boolean = false;
    date: string | null = null;
    dateSelected: string | null = null;
    datacenterSelected: number | null = null;

    maxDate = moment().format('yyyy-MM-DD');

    rules: any = rules;

    $refs!: {
        form: any;
    };

    locations = [DataCenters.DATA_CENTER_CARACAS, DataCenters.DATA_CENTER_VALENCIA];

    open() {
        this.dialog = true;
    }
    close() {
        this.$refs.form.reset();
        this.dialog = false;
    }

    setDate(date: string) {
        this.date = setMonthFormatDate(date);
    }

    async download() {
        this.isLoading = true;
        if (this.$refs.form.validate()) {
            const d = this.dateSelected!.split('-');
            const month = d[1];
            const year = d[0];
            const failed = await this.downloadReport({
                dataCenter: this.datacenterSelected!,
                month,
                year,
            });
            if (!failed) {
                this.close();
            } else {
                (failed as ExceptionMessage).showError();
            }
        }
        this.isLoading = false;
    }

    @reportsManagement.Action(ReportsManagementActions.DOWNLOAD_REPORTS)
    downloadReport!: (data: {
        dataCenter: number;
        month: string;
        year: string;
    }) => Promise<RequestResponse>;
}
